import { TextButton } from '@components/core-ui/form-elements/buttons/Button/variations/TextButton';
import { formatCentsPrice } from '@helpers/formatCentsPrice';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import { TransactionType } from '@pages/User/BillingAccountDetailsPage/components/TransactionType';
import { routes } from '@routes';
import { TransactionResponseDto } from 'app/API/models';
import { Panel } from './styles/Panel';
import { PanelActions } from './styles/PanelActions';
import { PanelHeader } from './styles/PanelHeader';
import { PanelSubtitle } from './styles/PanelSubtitle';
import { PanelTitle } from './styles/PanelTitle';
import { ReceiptLink } from './styles/ReceiptLink';
import { StateMessage } from './styles/StateMessage';
import { TransactionsTable } from './styles/TransactionsTable';
import { OutlinedLink } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';

type TProps = {
  billingAccountId: string;
  billingAccountName?: string;
  colSpan: number;
  isLoading: boolean;
  isOpen: boolean;
  onClose: () => void;
  transactions?: TransactionResponseDto[];
};

import { Td, Tr } from '@components/core-ui/Table';

export const InlineTransactionsRow = ({
  billingAccountId,
  billingAccountName,
  colSpan,
  isLoading,
  isOpen,
  onClose,
  transactions,
}: TProps) => {
  if (!isOpen) {
    return null;
  }

  const recentTransactions = transactions ?? [];

  return (
    <Tr>
      <Td colSpan={colSpan}>
        <Panel>
          <PanelHeader>
            <div>
              <PanelTitle>Recent Transactions</PanelTitle>
              <PanelSubtitle>
                Showing up to 5 of the latest transactions for {billingAccountName || 'this billing account'}.
              </PanelSubtitle>
            </div>
            <PanelActions>
              <OutlinedLink to={routes.adminTransactionsForBillingAccount.make(billingAccountId)}>
                View all
              </OutlinedLink>
              <TextButton type="button" onClick={onClose}>
                Close
              </TextButton>
            </PanelActions>
          </PanelHeader>

          {isLoading ? (
            <StateMessage>Loading latest transactions…</StateMessage>
          ) : recentTransactions.length ? (
            <TransactionsTable>
              <thead>
                <tr>
                  <th>Created</th>
                  <th>Title</th>
                  <th>Amount</th>
                  <th>Type</th>
                  <th>Receipt</th>
                </tr>
              </thead>
              <tbody>
                {recentTransactions.map((transaction) => (
                  <tr key={transaction.id}>
                    <td>{getAmericanTime(transaction.createdAt)}</td>
                    <td>
                      <div>{transaction.title}</div>
                      {transaction.stripeChargeId ? <small>Charge ID: {transaction.stripeChargeId}</small> : null}
                    </td>
                    <td>{formatCentsPrice(transaction.amount ?? 0)}</td>
                    <td>
                      <TransactionType type={transaction.code?.name || 'charge'} className="inline-flex" />
                    </td>
                    <td>
                      {transaction.stripeReceiptUrl ? (
                        <ReceiptLink href={transaction.stripeReceiptUrl} target="_blank" rel="noreferrer">
                          Receipt
                        </ReceiptLink>
                      ) : (
                        '—'
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </TransactionsTable>
          ) : (
            <StateMessage>No transactions yet.</StateMessage>
          )}
        </Panel>
      </Td>
    </Tr>
  );
};
